import { VueModule } from '@Foundation/utilities';
import Sprinklr from './code/Scripts/components/sprinklr.vue';

export default VueModule({
  components: {
    Sprinklr
  }
});
